import React from 'react';
import Styled from 'styled';
import { FormattedMessage } from 'react-intl';

import download from 'four-nets/icons/svg/icon_bookmark.svg';
import downloadOutlined from 'four-nets/icons/svg/icon_bookmark.svg';
import others from 'four-nets/icons/svg/icon_others.svg';

import Button from 'four-nets/photoblog/posts/common/footer/buttons/button/button';
import { ViewerConsumer } from 'four-nets/user/viewer/viewer';

import ImageLikesButtons from './image-likes-buttons/image-likes-buttons';
import defaultStyles from './buttons.scss';
import { PhotoblogPostAlbumCommentsButtonsFragment } from './buttons.graphql';

export interface Props extends PhotoblogPostAlbumCommentsButtonsFragment {
    styles: typeof defaultStyles;
    onMore?: (event: React.MouseEvent) => void;
    onSave?: (event: React.MouseEvent) => void;
    inFeed?: boolean;
}

class Buttons extends React.PureComponent<Props> {
    render() {
        const { styles, onMore, onSave, inViewerCollections, inFeed, ...image } = this.props;

        return (
            <div className={styles!.buttons}>
                <React.Fragment>
                    <ImageLikesButtons {...image} inFeed={inFeed} inViewerCollections={inViewerCollections} />
                    <ViewerConsumer>
                        {({ viewer }) =>
                            viewer ? (
                                <Button onClick={onSave} src={inViewerCollections ? download : downloadOutlined}>
                                    {inViewerCollections ? (
                                        <FormattedMessage id='SAVED' values={{ gender: 'v' }} />
                                    ) : (
                                        <FormattedMessage id='BUTTON_SAVE_IMAGE' />
                                    )}
                                </Button>
                            ) : null
                        }
                    </ViewerConsumer>
                    <Button onClick={onMore} src={others}>
                        <FormattedMessage id='BUTTON_LABEL_MORE' />
                    </Button>
                </React.Fragment>
            </div>
        );
    }
}

export default Styled(defaultStyles)(Buttons);
